import { FORMCONTROLLERSTYPE, QuestionType } from '../../core/constants/common';
import {
  BiCalendar, BiCalendarAlt, BiCheckSquare, BiGridAlt, BiHash, BiListCheck,
  BiListUl, BiParagraph, BiRadioCircleMarked, BiStar, BiTable, BiText, BiUpload,
} from 'react-icons/bi';

const ICON_MAP = {
  BiText, BiHash, BiParagraph, BiListUl, BiListCheck,
  BiRadioCircleMarked, BiCheckSquare, BiCalendarAlt, BiCalendar, BiUpload, BiStar, BiTable, BiGridAlt,
};

export const fieldRegistry = FORMCONTROLLERSTYPE.reduce((acc, item) => {
  acc[item.key] = {
    key: item.key,
    label: item.name,
    icon: ICON_MAP[item.icon] || BiText,
  };
  return acc;
}, {});

export const getFieldTypeMeta = (type) =>
  fieldRegistry[type] || {
    key: type,
    label: type || 'Question',
    icon: BiText,
  };

export const ALL_FIELD_TYPES = FORMCONTROLLERSTYPE;

export { QuestionType };
